import { PracticeTypeData } from "@/utils/practiceTypeData";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import StructuredData from "@/components/StructuredData";
import { getFAQPageSchema } from "@/utils/seoSchemas";
import { ScrollAnimatedSection } from "@/components/shared/ScrollAnimatedSection";

interface PracticeTypeFAQProps {
  practiceType: PracticeTypeData;
}

const PracticeTypeFAQ = ({ practiceType }: PracticeTypeFAQProps) => {
  const faqSchema = getFAQPageSchema(practiceType.faqs);

  return (
    <>
      <StructuredData data={faqSchema} />
      <section className="py-12 sm:py-16 md:py-20 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-accent/[0.02] via-background to-background" />
        <ScrollAnimatedSection>
          <div className="container mx-auto max-w-4xl px-4 relative z-10">
            <div className="text-center mb-12">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
                Häufige Fragen zu Cyberversicherungen für {practiceType.name}
              </h2>
            </div>

            <Accordion type="single" collapsible className="space-y-4">
              {practiceType.faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="bg-card border border-border rounded-lg px-6"
                >
                  <AccordionTrigger className="text-left hover:no-underline">
                    <span className="text-base font-semibold">{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </ScrollAnimatedSection>
      </section>
    </>
  );
};

export default PracticeTypeFAQ;
